import React from "react";

import { PropTypes } from "prop-types";

import {
  date2FormattedString,
  string2Datetime,
  time2FormattedString,
} from "../../../shared/utils/utils";
import Table from "../../../react_utils/table/Table";

export default function SgReadyHistoryTable({ sgReadyHistory }) {
  return (
    <Table
      columns={[
        { name: "Datum", key: "date" },
        { name: "Dauer [Std]", key: "duration" },
        { name: "Start", key: "start" },
        { name: "Ende", key: "end" },
      ]}
      rows={sgReadyHistory.map((info) => ({
        date: date2FormattedString(string2Datetime(info.start_time)),
        duration: info.duration,
        start: time2FormattedString(string2Datetime(info.start_time)),
        end: time2FormattedString(string2Datetime(info.end_time)),
      }))}
    />
  );
}

SgReadyHistoryTable.propTypes = {
  sgReadyHistory: PropTypes.arrayOf(PropTypes.object),
};
